export default class CommonUtils {
  static path = (url: string) => {
    const pathArray = url.split('/');

    pathArray.pop();

    const finalPath = pathArray.join('/');

    return finalPath;
  };
}
